export enum UploadManagerStatus {
	Standby,
	Preparing,
	Paused,
	Done,
	Failed,
	Uploading
}
